import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import {
  QUALITE_PRESTATIONS_OPTIONS,
  APPRECIATION_4_OPTIONS,
  APPRECIATION_5_OPTIONS,
  APPRECIATION_BCG_OPTIONS,
  LIQUIDITE_BIEN_OPTIONS,
  CATEGORIE_BIEN_OPTIONS,
} from '@/constants/enums';

export default function SectionPrestations({ data, onChange, formatRapport }) {
  const val = (field) =>
    field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Input
          label="Revêtements de sols"
          name="prestations.revetements_sols"
          value={val('prestations.revetements_sols')}
          onChange={handleChange('prestations.revetements_sols')}
        />
        <Input
          label="Revêtements de murs"
          name="prestations.revetements_murs"
          value={val('prestations.revetements_murs')}
          onChange={handleChange('prestations.revetements_murs')}
        />
        <Input
          label="Revêtements de plafonds"
          name="prestations.revetements_plafonds"
          value={val('prestations.revetements_plafonds')}
          onChange={handleChange('prestations.revetements_plafonds')}
        />

        {formatRapport !== 'bcg' && (
          <>
            <Select
              label="Qualité des prestations"
              name="prestations.qualite_prestations"
              value={val('prestations.qualite_prestations')}
              options={QUALITE_PRESTATIONS_OPTIONS}
              onChange={handleChange('prestations.qualite_prestations')}
            />
            <Select
              label="Niveau des prestations"
              name="prestations.niveau_prestations"
              value={val('prestations.niveau_prestations')}
              options={APPRECIATION_4_OPTIONS}
              onChange={handleChange('prestations.niveau_prestations')}
            />
          </>
        )}

        {formatRapport === 'bcg' && (
          <>
            <Select
              label="Qualité des traitements (BCG)"
              name="prestations.qualite_traitements_bcg"
              value={val('prestations.qualite_traitements_bcg')}
              options={APPRECIATION_5_OPTIONS}
              onChange={handleChange('prestations.qualite_traitements_bcg')}
            />
            <Select
              label="Éclairage naturel (BCG)"
              name="prestations.eclairage_naturel_bcg"
              value={val('prestations.eclairage_naturel_bcg')}
              options={APPRECIATION_4_OPTIONS}
              onChange={handleChange('prestations.eclairage_naturel_bcg')}
            />
          </>
        )}
      </div>

      {formatRapport === 'bcg' && (
        <>
          <h3 className="text-lg font-semibold text-slate-800">Appréciations BCG</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <Select
              label="Appréciation générale"
              name="appreciations_bcg.appreciation_generale"
              value={val('appreciations_bcg.appreciation_generale')}
              options={APPRECIATION_BCG_OPTIONS}
              onChange={handleChange('appreciations_bcg.appreciation_generale')}
            />
            <Select
              label="Liquidité du bien"
              name="appreciations_bcg.liquidite"
              value={val('appreciations_bcg.liquidite')}
              options={LIQUIDITE_BIEN_OPTIONS}
              onChange={handleChange('appreciations_bcg.liquidite')}
            />
            <Select
              label="Catégorie du bien"
              name="appreciations_bcg.categorie"
              value={val('appreciations_bcg.categorie')}
              options={CATEGORIE_BIEN_OPTIONS}
              onChange={handleChange('appreciations_bcg.categorie')}
            />
          </div>
        </>
      )}
    </div>
  );
}
